<template>
  <input
    type="file"
    class="file-input file-input-sm file-input-bordered w-full max-w-xs"
    @change="onFileChange($event)"
    :multiple="multiple"
    :accept="accept"
  />
</template>

<script>
export default {
  props: {
    modelValue: {
      type: [Object, FileList, File],
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    accept: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      file: null,
      files: null,
    };
  },
  methods: {
    onFileChange(event) {
      if (this.multiple) {
        this.$emit('update:modelValue', event.target.files);
        this.files = event.target.files;
      } else {
        this.$emit('update:modelValue', event.target.files[0]);
        this.file = event.target.files[0];
      }
    },
  },
};
</script>
